import FormattedMessage from 'I18n/components/FormattedMessage';
import { normalizePurchaseMotion } from '../../../utils/purchaseMotionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const usePurchaseMotionCTAText = ({
  purchaseMotion,
  purchaseMotionLocation,
  children
}) => {
  const normalizedPurchaseMotion = normalizePurchaseMotion(String(purchaseMotion));
  if (normalizedPurchaseMotion === 'TRIAL') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pricingCtas.startTrial"
    });
  }
  if (purchaseMotionLocation === 'PRICING_PAGE_INTERSTITIAL' && (normalizedPurchaseMotion === 'BUY_ADDITIONAL_SEATS' || normalizedPurchaseMotion === 'BUY_TOUCHLESS')) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "interstitial.continueToCheckoutCta"
    });
  }
  if (purchaseMotionLocation === 'PRICING_PAGE_INTERSTITIAL' && normalizedPurchaseMotion === 'buyAdditionalContacts') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "interstitial.continueCta"
    });
  }
  return children;
};